import React from "react";
import { Stack, Typography } from "@mui/material";

import {
  HubButton,
  HubCardStack,
  HubHookFormInput,
  HubHookFormSelect,
} from "../../components";
import { FOUNDRIES } from "../../constants";

const CalendarGoalsForm = ({
  locationId,
  setLocationId,
  canEdit,
  isLoading,
  isSaving,
}) => {
  const disabled = !canEdit || isLoading || isSaving;
  return (
    <HubCardStack gap="15px">
      <Typography variant="boldCaptionL">Foundry Targets</Typography>
      <HubHookFormSelect
        name="locationId"
        label="Location"
        options={FOUNDRIES}
        defaultValue={locationId}
        onChange={setLocationId}
        required
      />
      <HubHookFormInput
        name="revenueGoal"
        label="Revenue Target"
        disabled={disabled}
        isCurrency
        required
      />
      <HubHookFormInput
        name="waxHourGoal"
        label="Wax Hour Target"
        endAdornment="hrs"
        disabled={disabled}
        isDecimal
        required
      />
      <HubButton
        label="Save Targets"
        variant="contained"
        size="xsmall"
        type="submit"
        disabled={disabled}
      />
    </HubCardStack>
  );
};

export default CalendarGoalsForm;
